import request from "@/service";

/* 查询试卷分页列表 */
export function getExamPaperList(params) {
  return request({
    url: `/study/exam/paper/page`,
    method: "get",
    params
  });
}

/* 试卷新增 */
export function saveExamPaper(params) {
  return request({
    url: `/study/exam/paper/save`,
    method: "post",
    data: params
  });
}

/* 试卷修改 */
export function editExamPaper(params) {
  return request({
    url: `/study/exam/paper/update`,
    method: "put",
    data: params
  });
}

/* 试卷详情 */
export function getExamPaperInfo(params) {
  return request({
    url: `/study/exam/paper/info/${params}`,
    method: "get"
  });
}

/* 试卷删除 */
export function deletePaper(params) {
  return request({
    url: `/study/exam/paper/delete`,
    method: "delete",
    data: params
  });
}

/* 复制试卷 */
export function copyExamPaper(params) {
  return request({
    url: `/study/exam/paper/copy`,
    method: "post",
    data: params
  });
}

/* 发布/取消发布 */
export function publishExamPaper(params) {
  return request({
    url: `/study/exam/paper/publish`,
    method: "put",
    data: params
  });
}

/* 试卷预览 */
export function previewExamPaperInfo(params) {
  return request({
    url: `/study/exam/paper/preview/${params}`,
    method: "get"
  });
}

/* 已发布试卷名称列表 */
export function getPublishedPaperList(params) {
  return request({
    url: `/study/exam/paper/page`,
    method: "get",
    params
  });
}
